"use strict";

angular.module('app.models.DatapointValue', []).factory('__DatapointValue', function (restmod, appConfig, $timeout) {
    'ngInject';
    
    return restmod.model('/Datapoint/ReadValues')
        .mix('BaseModel')
        .mix({

      //  '_type':{map: '$type'},
        prepareValue: function () {


        }


    }).mix({
        // Fake resource bound
            $pk: 'DatapointConfigId',
        //owner: { hasOne: '__DatapointConfig', hasOne: '__Device' },
        $config: {name: 'ResponseData', plural: 'ResponseData'},
        $hooks: {

            'before-fetch-many': function (_req) {
                _req.method = 'POST';
                _req.data = _req.params;
                delete _req.data.$UI;
                delete _req.data.$pk;
                delete _req.data.$resolved;

                _req.params = '';
            },
            'before-fetch': function (_req) {
                _req.method = 'POST';
                _req.data = _req.params;
                _req.params = '';
            },

            'before-save': function (_req) {
                _req.params = '';

                _req.method = 'POST';
                var o;
                if(_req.data._type != undefined)
                {
                    o = {$type: this._type};

                }else{
                    o = {$type: _req.data.$type};

                }


                var u = _req.data;
                delete u.DetailedText;
                delete u.DisplayText;
                delete u.ExceptionData;
                delete u.StatusCode;
                // delete u._type;

               // console.log('---->',_req);
                _req.data = {'DatapointValues': [angular.extend(o, u)]};
            },


            'after-feed': function (data) {
                if (this.$UI == undefined) {
                    this.$UI = {};
                }

                 //data._type  = data.$type;
                //data.Value = data.Value;
            },
            'refresh-value': function () {
                //this.$saveCollection
            }
        },

        $extend: {
            $save: function () {
                var original = this;
                this.$url = function () {
                    return appConfig().api_host + 'Datapoint/WriteValues';
                };
                return this.$super();
            },
            $saveCollection: function (params) {
                return this.$decorate({
                    'before-request': function (_req) {
                        _req.url = appConfig().api_host + 'Datapoint/WriteValues';
                        _req.method = 'POST';
                        _req.data = {'DatapointValues': this};
                        //alert()
                    }
                }, function () {
                    // every method from same context called inside this function will be decorated.
                    return this.$super();
                });
            },
            $read : function(){
                return this.$send({
                        url: appConfig().api_host + 'Datapoint/ReadValues',
                        method: 'POST',
                        data: {
                            'DatapointValues': [{
                                DatapointConfigId: this.DatapointConfigId,
                                DeviceId: this.DeviceId
                            }]
                        }
                    }
               ,function(data){

                    this.Value = data.data[0].Value;
                    this.Flags = data.data[0].Flags;

                });


            },
            $readValue: function (d) {
                return this.$decorate({
                    'before-request': function (_req) {
                        _req.url = appConfig().api_host + 'Datapoint/ReadValues';
                        _req.method = 'POST';
                        _req.data = {
                            'DatapointValues': [{
                                DatapointConfigId: this.DatapointConfigId,
                                DeviceId: this.DeviceId
                            }]
                        };

                        if(d != undefined)
                        {
                            _req.data = {
                                'DatapointValues': [d]};
                        }

                    }
                }, function () {
                    // every method from same context called inside this function will be decorated.
                    return this.$fetch();
                });


            },
            Scope: {
                $collection: function (params) {
                    var original = this;
                    var o = {
                        $urlFor: function () {
                            return original.$urlFor('/Datapoint/ReadValues');
                        }
                    };
                    return this.$super({'DatapointValues': params}, o);
                },

                $search: function (a) {
                    return $collection(a).$refresh();
                },



            }
        },
        Collection: {
            $GetByConfigId: function (list) {
                return this.$search(list, {
                    $urlFor: function () {
                        return '/Datapoint/GetConfigs';
                    }
                });
            }
        }

    });
});